import { render, staticRenderFns } from "./VButton.vue?vue&type=template&id=35a568fe&scoped=true&"
import script from "./VButton.vue?vue&type=script&lang=js&"
export * from "./VButton.vue?vue&type=script&lang=js&"
import style0 from "./VButton.vue?vue&type=style&index=0&id=35a568fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a568fe",
  null
  
)

export default component.exports